import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const CANCEL = 'cancel'
export const SAVE = 'save'
export const SAVED_SUCCESS = 'saved-succes'

export default {
  [PORTUGUESE]: {
    [CANCEL]: 'Cancelar',
    [SAVE]: 'Salvar',
    [SAVED_SUCCESS]: 'As configurações foram salvas com sucesso',
  },

  [ENGLISH]: {
    [CANCEL]: 'Cancel',
    [SAVE]: 'Save',
    [SAVED_SUCCESS]: 'Settings have been saved successfully',
  },

  [SPANISH]: {
    [CANCEL]: 'Cancelar',
    [SAVE]: 'Ahorrar',
    [SAVED_SUCCESS]: 'Los ajustes se han guardado correctamente',
  },
}
